module.exports = "/images/dimensions-box.svg?3360257793cc5576dada7181283be2bb";